import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignInComponent } from './sign-in.component';
import { UnauthorizedUserComponent } from '../unauthorized-user/unauthorized-user.component';
import { AppComponent } from '../app.component';
import { SignInRedirectComponent } from '../sign-in-redirect/sign-in-redirect.component';
import { MaintenanceComponent } from '../maintenance/maintenance.component';

const routes: Routes = [
  { path: '', redirectTo:'/signin', pathMatch:'full' },
  { path: 'signin', component:SignInComponent },
  { path: 'response-oidc', component: SignInRedirectComponent },
  { path: 'Unauthorized', component: UnauthorizedUserComponent },
  { path: 'Maintenance', component: MaintenanceComponent },

  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AuthenticationAuthorizationRoutingModule { }
